import { Link, Typography } from "@mui/material";
import React from "react";
import { Styled } from "./styles";

interface Props {
    isAuth?: boolean;
}

const Copyright: React.FC<Props> = ({ isAuth }) => {
    return (
        <Styled.Container isAuth={isAuth}>
            <Typography variant="caption">
                <Link
                    href="https://dippi.app"
                    underline="none"
                    target="_blank"
                    rel="noreferrer noopener"
                    color={"#929292"}
                    marginRight="10px"
                >
                    &copy; Copyright Dippi {new Date().getFullYear()}
                </Link>
            </Typography>
            <Typography variant="caption">
                <Link
                    href="https://dippi.app/privacy-policy"
                    underline="none"
                    target="_blank"
                    rel="noreferrer noopener"
                    color={"#929292"}
                    marginRight="10px"
                >
                    Privacy & terms
                </Link>
            </Typography>
        </Styled.Container>
    );
};

export default Copyright;
